module.exports = __webpack_public_path__ + "img/whatsApp.3f8567e3.svg";